
import React, { useState } from 'react';
import styles from './matrixDisplayArea.module.css';

import SilentStudyArea from '../../matrix_display_area_components/SilentStudyArea/SilentStudyArea.jsx';
import CalendarForDiscussAndLearn from '../../matrix_display_area_components/CalendarForDiscussAndLearn.jsx';
import DiscussAndLearnArea from '../../matrix_display_area_components/DiscussAndLearnArea/DiscussAndLearnArea.jsx';
import MyProfile from '../../miscellaneous/MyProfile/MyProfile.jsx';


import ExpertCards from '../../matrix_display_area_components/ExpertCards.jsx';
import CalendarForAskingDoubt from '../../matrix_display_area_components/CalendarForAskingDoubt.jsx';
import ExpertScheduleCalendar from '../../matrix_display_area_components/ExpertScheduleCalendar.jsx';

import { useGlobalState } from '../../global_state_components/GlobalStateProvider.jsx';
import Settings from '../../miscellaneous/Settings/Settings.jsx';
import Notification from '../../miscellaneous/Notification/Notification.jsx';
import AllSessions from '../UpcomingSessionPanel/AllSessions/AllSessions.jsx';

function MatrixDisplayArea() {
  const {isAllSessionsClicked, setIsAllSessionsClicked, category, showMyProfile, showNotification, showSettings} = useGlobalState();

  //console.log("useGlobalState() : "+useGlobalState()); // Debug: Check what this returns
  //console.log("selectedCategory : "+category);

  if (isAllSessionsClicked){
    return(
      <div className={styles.matrix_display_area_div}>
        {showMyProfile && <MyProfile/>}
        {showNotification && <Notification/>}
        {showSettings && <Settings/>}
        <AllSessions/>
      </div>
    );
  }





  if (category === 'discuss_and_learn'){
    return(
      <div className={styles.matrix_display_area_div}>
        {showMyProfile && <MyProfile/>}
        {showNotification && <Notification/>}
        {showSettings && <Settings/>}
        <DiscussAndLearnArea/>
      </div>
    );
  }else if(category === 'silent_study'){
    return(
      <div className={styles.matrix_display_area_div}>
        {showMyProfile && <MyProfile/>}
        {showNotification && <Notification/>}
        {showSettings && <Settings/>}
        <SilentStudyArea/>
      </div>
    );
  }else if(category === 'quick_doubt'){
    return(
      <div className={styles.matrix_display_area_div}>
        {showMyProfile && <MyProfile/>}
        {showNotification && <Notification/>}
        {showSettings && <Settings/>}
        <CalendarForAskingDoubt/>
      </div>
    );
  }else if(category === 'learn_from_expert'){
    return(
      <div className={styles.matrix_display_area_div}>
        {showMyProfile && <MyProfile/>}
        {showNotification && <Notification/>}
        {showSettings && <Settings/>}
        <ExpertCards/>
      </div>
    );
  }else if(category === 'expert_schedule'){
    return(
      <div className={styles.matrix_display_area_div}>
        {showMyProfile && <MyProfile/>}
        {showNotification && <Notification/>}
        {showSettings && <Settings/>}
        <ExpertScheduleCalendar/>
      </div>
    );
  }
}

export default MatrixDisplayArea;